import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=032bd8d9&scoped=true"
import script from "./spec.vue?vue&type=script&lang=js"
export * from "./spec.vue?vue&type=script&lang=js"
import style0 from "./spec.vue?vue&type=style&index=0&id=032bd8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032bd8d9",
  null
  
)

export default component.exports